module.exports = __webpack_public_path__ + "img/window-close.06d8ab6b.svg";